module.exports = __webpack_public_path__ + "static/media/zm.c0520a2b.svg";